import { forwardRef } from 'react';
import { Divider } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const ItemDivider = forwardRef(({ className }, ref) => {
  const styles = useStyles();

  return (
    <Divider
      className={cx(styles.root, className)}
      ref={ref}
    />
  );
});

ItemDivider.propTypes = {
  className: PropTypes.string,
};

ItemDivider.defaultProps = {
  className: '',
};
